import { CreateAccountSessionState } from './createAccountSession.types'

const initialState: CreateAccountSessionState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
